// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__1A9iX"};